export default {
  add: {
    position: 'absolute',
    top: 15,
    left: 0,
    zIndex: 1,
  },
  noData: {
    fontSize: 200,
    color: 'lightgrey',
  },
  icon: {
    paddingLeft: 3,
    paddingRight: 3,
  },
  // remove: {
  //   position: 'absolute',
  //   top: 15,
  //   left: 50,
  //   zIndex: 1000,
  // },
}


// WEBPACK FOOTER //
// ./src/components/Jobs/JobsGrid/styles.js